import React, { useState, useEffect, useRef } from "react";
import { Menu, Dropdown, Icon, Table } from "antd";
import { useHistory } from "react-router-dom";
import editIcon from "../../../../assets/images/budget/dropdown.png";
import menuIcon from "../../../../assets/images/DeathModuleNew/Menu.png";
import NewLoader from "../../../../components/styled-components/loader/NewLoader";
import swal from "sweetalert";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import "../AddTransaction/AddTransaction.css";
import "./style/recurringPattren.css";
import { AddRecurringPattren } from "./RecurringModals/AddRecurringPattren";
import BUDGET_API from "../../../../apis/budget.api";
import { EditRecurringToken } from "./RecurringModals/EditRecurringToken";
import { EditRecurringPattren } from "./RecurringModals/EditRecurringPattren";
import { SystemRecurringTransactions } from "./SystemRecurringTransactions";

export const RecurringPattren = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [recurringTokens, setRecurringTokens] = useState([]);
  const [cachedData, setCachedData] = useState({});
  const [addModal, setAddModal] = useState(false);
  const [tokenModal, setTokenModal] = useState(false);
  const [pattrenModal, setPattrenModal] = useState(false);
  const [fetchRecuuring, setFetchRecuuring] = useState(false);
  const [recurring, setRecurring] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  

  const [formData, setFormData] = useState(null);
  const [modalTitle, setModalTitle] = useState("Add Rule");
  const [dropdown, setDropdown] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const requestId = useRef(0);
  const handleCancelPattren = () => {
    setAddModal(false);
    setFormData(null);
    setFetchRecuuring(!fetchRecuuring);
    setModalTitle("Add Rule");
  };

  const updatePreviousTransactions = async (payload) => {
    try {
      setLoading(true);
      const id = payload.id;
      let data = await BUDGET_API.updatePreviousTransactionsForRecurring(id);
      console.log("datadata", data);
      setFetchRecuuring(!fetchRecuuring);
      setRecurring(!recurring);
      if (data && data.success) {
        swal(
          "Success",
          "Rule Pattern Applied to Existing Transactions",
          "success"
        );
      }
      if (data && data.statusCode === 400) {
        swal("Error", data.message, "error");
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const updatePreviousTransactionsPattren = async (payload) => {
    try {
      setLoading(true);
      const tokenId = payload.tokenId;
      const patternId = payload.id;

      let data = await BUDGET_API.updatePreviousTransactionsForRecurring(
        tokenId,
        patternId
      );
      setFetchRecuuring(!fetchRecuuring);
      setRecurring(!recurring);
      if (data && data.success) {
        swal("Success", "Rule Pattern to Existing Transactions", "success");
      }
      if (data && data.statusCode === 400) {
        swal("Error", data.message, "error");
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const createRecuuringTransactions = async (payloadData) => {
    try {
      setLoading(true);
      const selectedTransactionsIds = payloadData.selectedTransactions && payloadData.selectedTransactions.map((row) => row.id);
      // OLD PAYLOAD
      // const payload={
      //   tokenId : payloadData.tokenId,
      //   patternId : payloadData.patternId,
      //   transactionIds:selectedTransactionsIds,
      // }
      const payload = (selectAll || payloadData.selectAll)
        ? {
          tokenId: payloadData.tokenId,
          patternId: payloadData.patternId,
          selectAll: true,
        }
        : {
          tokenId: payloadData.tokenId,
          patternId: payloadData.patternId,
          transactionIds: selectedTransactionsIds,
        };

      let data = await BUDGET_API.createTransactionsForRecurring(payload);
      setFetchRecuuring(!fetchRecuuring);
      setRecurring(!recurring);
      if (data && data.success) {
        swal("Success", data.message || "Recurring Transactions Created!", "success");
      }
      if (data && data.statusCode === 400) {
        swal("Error", data.message, "error");
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleSavePattren = async (selectedTransactions, updatedPatterns) => {

    const finalPatterns = updatedPatterns;
    setAddModal(false);
    if (modalTitle === "Add Rule") {
      try {
        let payload = {
          ...formData,
          patterns: updatedPatterns
        };
        // OLD PAYLOAD..
        // console.log("formData", formData);Add commentMore actions
        // setAddModal(false);
        // if (modalTitle === "Add Rule") {
        //   try {
        //     let payload = {
        //       ...formData,
        //     };

        setLoading(true);
        let data = await BUDGET_API.addRecurringToken(payload);
        console.log("data token", data);
        setFetchRecuuring(!fetchRecuuring);

        if (data && data.statusCode === 201) {
          swal("Success", data.message, "success");
          await getRecurringTokenAfterDelete(1);
          setFetchRecuuring(!fetchRecuuring);
          const payloadData = {
            tokenId: data.data.token.id,
            patternId: data.data.patterns && data.data.patterns[0].id,
            selectedTransactions: selectedTransactions,
          }
          console.log("payloadData", payloadData)
          await createRecuuringTransactions(payloadData);
          if (formData && formData.applyRuleToExistingTransactions) {
            console.log('dda', data.data)
            await updatePreviousTransactions(data.data.token);
          }

          // swal({
          //   title: "Are you sure?",
          //   text: "Are you sure you want to apply this Rule Pattern to Existing Transactions.",
          //   icon: "warning",
          //   type: "warning",
          //   buttons: {
          //     upgrade: {
          //       text: "No",
          //       value: "upgrade",
          //       visible: true,
          //     },
          //     ok: {
          //       text: "Yes",
          //       value: "ok",
          //       visible: true,
          //     },
          //   },
          // }).then((value) => {
          //   debugger
          //   console.log("Button value clicked:", value); // Debugging line to show the value
          //   switch (value) {
          //     case "upgrade":
          //       console.log("calling upgrade");
          //       // updatePayment();
          //       break;

          //     case "ok":
          //       console.log("calling ok");
          //       updatePreviousTransactions(data.data);
          //       break;

          //     default:
          //       console.log("No action taken");
          //       break;
          //   }
          // });
        }
        if (data && data.statusCode === 400) {
          swal("Error", data.message, "error");
        }
        setLoading(false);
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    }
    setFormData(null);
    setModalTitle("Add Rule");
  };
  const handleSaveAddPattren = async (payload) => {
    try {
      setLoading(true);
      let data = await BUDGET_API.addRecurringTokenPattren(payload);
      if (data && data.statusCode === 200) {
        setLoading(false);
        console.log("pattren data", data.body.result);
        // swal({
        //   title: "Are you sure?",
        //   text: "Are you sure you want to apply this Rule Pattern to Existing Transactions.",
        //   icon: "warning",
        //   type: "warning",
        //   buttons: {
        //     upgrade: {
        //       text: "No",
        //       value: "upgrade",
        //       visible: true,
        //     },
        //     ok: {
        //       text: "Yes",
        //       value: "ok",
        //       visible: true,
        //     },
        //   },
        // }).then((value) => {
        //   console.log("Button value clicked:", value); // Debugging line to show the value
        //   switch (value) {
        //     case "upgrade":
        //       console.log("calling upgrade");
        //       // updatePayment();
        //       break;

        //     case "ok":
        //       console.log("calling ok");
        //       updatePreviousTransactionsPattren(data.body.result);
        //       break;

        //     default:
        //       console.log("No action taken");
        //       break;
        //   }
        // });
        handleCancelPattrenUpdate()
        return data;
        // await getRecurringTokenAfterDelete(1);
      }
      if (data && data.statusCode === 400) {
        swal("Error", data.message, "error");
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const handleCancelPattrenUpdate = async () => {
    setPattrenModal(false);
    setFormData(null);
    setFetchRecuuring(!fetchRecuuring);
    await getRecurringTokenAfterDelete(1);
  };
  const handleCancelTokenUpdate = () => {
    setTokenModal(false);
    setFormData(null);
  };
  const handleUpdateToken = async () => {
    console.log("formData", formData);
    setTokenModal(false);
    try {
      setLoading(true);
      let payload = {
        token: formData && formData.token,
        tokenId: formData && formData.id,
        applyRuleToExistingTransactions: formData && formData.applyRuleToExistingTransactions ? formData.applyRuleToExistingTransactions : false,
      };
      let data = await BUDGET_API.updateRecurringToken(payload);
      setFetchRecuuring(!fetchRecuuring);
      if (data && data.statusCode === 200) {
        swal("Success", data.message, "success");
        await getRecurringTokenAfterDelete(1);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
    setFormData(null);
  };
  const handleUpdateTokenPriority = async (payloadData) => {
    try {
      setLoading(true);
      console.log("formData update", payloadData);
      let payload = {
        token: payloadData && payloadData.token,
        priority: payloadData && payloadData.priority,
        tokenId: payloadData && payloadData.id,
      };
      let data = await BUDGET_API.updateRecurringToken(payload);
      // setFetchRecuuring(!fetchRecuuring);
      if (data && data.statusCode === 200) {
        swal("Success", data.message, "success");
        await getRecurringTokenAfterDelete(1);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const handleUpdateTokenPattren = async (payload) => {
    try {
      setLoading(true);
      console.log("formData", payload);
      const payloadUpdate = {
        tokenId: payload.tokenId,
        patternId: payload.patternId,
        pattern: payload.pattern,
      }
      let data = await BUDGET_API.updateRecurringTokenPattren(payloadUpdate);
      // const payloadData={
      //   tokenId : payload.tokenId,
      //   patternId : payload.patternId,
      //   selectedTransactions:payload.selectedTransactions,
      // }
      const payloadData = payload && payload.selectAll
        ? {
          tokenId: payloadUpdate.tokenId,
          patternId: payloadUpdate.patternId,
          selectAll: true,
        }
        : {
          tokenId: payloadUpdate.tokenId,
          patternId: payloadUpdate.patternId,
          selectedTransactions: payload.selectedTransactions && payload.selectedTransactions.length > 0 ? [...payload.selectedTransactions] : [],
        };
      await createRecuuringTransactions(payloadData);
      setFetchRecuuring(!fetchRecuuring);
      // if (data && data.status === 200) {
      //   swal("Success", data.message, "success");
      //   await getRecurringToken();
      // }
      handleCancelPattrenUpdate()
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const handleDeletePattren = async (payload) => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to delete this Recurring Rule Pattern?",
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, Delete it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        try {
          setLoading(true);
          // let payload={tokenId:id,patternId:id}
          const res = await BUDGET_API.deleteRecurringTokenPattern(payload);
          if (res && res.statusCode === 200) {
            await getRecurringTokenAfterDelete(1);
            setFetchRecuuring(!fetchRecuuring);
            swal(
              "Deleted!",
              "Your Recurring Rule Pattern has been deleted.",
              "success"
            );
          }
          setLoading(false);
        } catch (error) {
          console.log(error);
          setLoading(false);
        }
      } else {
        swal("Cancelled", "Your Recurring Rule Pattern is safe :)", "error");
      }
    });
  };
  const handleInputChange = (name, value) => {
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const updateStateWithData = (datares) => {
    console.log("datares", datares);
    if (datares && datares.body.data) {
      const sortedData = [...datares.body.data].sort((a, b) => {
        if (a.priority !== undefined && b.priority !== undefined) {
          return a.priority - b.priority;
        }
        return 0; // Keep original order if priority doesn't exist
      });
      setRecurringTokens(sortedData);
    }
    if (datares && datares.body) {
      setTotalPages(Math.ceil(datares.body.totalPages));
    }
  };
  const getRecurringToken = async (page, search = "") => {
    const currentRequestId = ++requestId.current;
    if (!search && cachedData && cachedData[page]) {
      setLoading(false);
      updateStateWithData(cachedData[page]);
      return;
    }
    try {
      setLoading(true);
      let data = await BUDGET_API.fetchRecurringToken(page, search);
      if (currentRequestId !== requestId.current) return;
      if (data && data.body) {
        if (!search) {
          setCachedData((prevState) => ({
            ...prevState,
            [page]: data,
          }));
        }
        updateStateWithData(data);
        console.log("alldata", data.body);
      }
      setLoading(false);
    } catch (error) {
      if (currentRequestId !== requestId.current) return;
      console.log(error);
      setLoading(false);
    }
  };
  const getRecurringTokenAfterDelete = async (page) => {
    try {
      setLoading(true);
      let data = await BUDGET_API.fetchRecurringToken(page);
      if (data && data.body) {
        setCachedData((prevState) => ({
          ...prevState,
          [page]: data,
        }));
        updateStateWithData(data);
        console.log("alldata", data.body);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const deleteToken = async (id) => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to delete this Recurring Rule?",
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, Delete it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        try {
          setLoading(true);
          let payload = { tokenId: id };
          const res = await BUDGET_API.deleteRecurringToken(payload);
          if (res && res.statusCode === 200) {
            setCachedData({});
            await getRecurringTokenAfterDelete(1);
            setFetchRecuuring(!fetchRecuuring);
            swal(
              "Deleted!",
              "Your Recurring Rule has been deleted.",
              "success"
            );
          }
          setLoading(false);
        } catch (error) {
          console.log(error);
          setLoading(false);
        }
      } else {
        swal("Cancelled", "Your Recurring Rule is safe :)", "error");
      }
    });
  };
  const openModal = () => {
    setModalTitle("Edit Token");
    setAddModal(true);
  };
  useEffect(() => {
    getRecurringToken(currentPage, searchQuery);
  }, [currentPage, searchQuery]);

  useEffect(() => {
    setAddModal(true);

  }, []);

  const onDragEnd = (result) => {
    if (
      !result.destination ||
      result.source.index === undefined ||
      result.destination.index === undefined
    )
      return;

    const newData = recurringTokens && [...recurringTokens];
    const [movedItem] = newData.splice(result.source.index, 1);
    newData.splice(result.destination.index, 0, movedItem);
    const updatedData = newData.map((item, index) => ({
      ...item,
      priority: index + 1, // Assign new index as priority
    }));
    const updatedMovedItem = updatedData.find(
      (item) => item.id === movedItem.id
    );
    handleUpdateTokenPriority(updatedMovedItem);
    console.log("newData", updatedData);
    setRecurringTokens(updatedData);
  };
  const DraggableBodyRow = ({ index, className, style, ...props }) => {
    const { recurringTokens } = props; // Get full data source
    const rowKey = props["data-row-key"];
    const record =
      recurringTokens && recurringTokens.find((item) => item.id === rowKey); // Find index
    if (!record) return <tr {...props} />; // If no record, render normally

    return (
      <Draggable
        key={record && record.id}
        draggableId={record && record.id.toString()}
        index={index}
        style={{ width: "100%" }}
      >
        {(provided, snapshot) => (
          <tr
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            className={`${className} ${snapshot.isDragging ? "dragging" : ""}`}
            style={{
              ...style,
              ...provided.draggableProps.style,
              width: snapshot.isDragging ? "100%" : "auto",
              background: snapshot.isDragging ? "white" : "inherit",
            }}
            {...props}
          />
        )}
      </Draggable>
    );
  };
  const DraggableContainer = (props) => (
    <Droppable droppableId="droppable" direction="vertical" type="ROW">
      {(provided) => (
        <tbody
          ref={provided.innerRef}
          {...provided.droppableProps}
          {...props}
        />
      )}
    </Droppable>
  );

  const cols = [
    {
      title: "Priority",
      dataIndex: "priority",
      key: "priority",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Rule",
      dataIndex: "token",
      key: "token",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Patterns",
      dataIndex: "recurring_patterns",
      key: "recurring_patterns",
      render: (pattrens) => {
        if (!pattrens || !Array.isArray(pattrens) || pattrens.length === 0) {
          return "N/A";
        }
        console.log("pattrens", pattrens);
        const displayPatterns = pattrens
          .slice(0, 2)
          .map((item) => item.pattern)
          .join(", ");
        const suffix = pattrens.length > 2 ? "..." : "";
        return `${displayPatterns}${suffix}`;
      },
    },
    {
      title: "Action",
      render: (record, index) => {
        return (
          <div key={index}>
            <div
              onClick={() => {
                setSelectedIndex(record.id);
                setDropdown(!dropdown);
              }}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                padding: "0px 16px",
                width: "5px",
              }}
            >
              <img src={menuIcon} alt="menuIcon"></img>
            </div>
            {dropdown && selectedIndex === record.id && (
              <React.Fragment>
                <div
                  onClick={() => {
                    setDropdown(false);
                  }}
                  className="recurring-dropdown"
                ></div>

                <div
                  class="dropdown"
                  style={{ zIndex: "9999", right: "12%", width: "13%" }}
                >
                  <ul className="dropdownul">
                    {/* <li
                      className="liHover"
                      onClick={() => {
                        setFormData(record);
                        setTokenModal(true);
                        setDropdown(false);
                      }}
                    >
                      Update Rule
                    </li> */}
                    <li
                      className="liHover"
                      onClick={() => {
                        setFormData(record);
                        setPattrenModal(true);
                        setDropdown(false);
                      }}
                    >
                      Update Rule
                    </li>
                    <li
                      className="liHover"
                      onClick={() => {
                        deleteToken(record.id);
                        setDropdown(false);
                      }}
                    >
                      Delete
                    </li>
                  </ul>
                </div>
              </React.Fragment>
            )}{" "}
          </div>
        );
      },
    },
  ];

  return (
    <div className="addBudgetMain" style={{ position: "relative" }}>
      <div className="addbudgetSection">
        <div className="recurring-pattren-container">
          <div className="addTitle">
            Recurring Rule{" "}
            <span>
              <Dropdown
                trigger={["click"]}
                overlay={
                  <Menu>
                    <Menu.Item>
                      <div
                        onClick={() => {
                          history.push("/budget");
                        }}
                      >
                        Dashboard
                      </div>
                    </Menu.Item>
                    <Menu.Item>
                      <div
                        onClick={() => {
                          history.push("/budget/add/transaction");
                        }}
                      >
                        Transactions
                      </div>
                    </Menu.Item>
                    <Menu.Item>
                      <div
                        onClick={() => {
                          history.push("/budget/add/budget");
                        }}
                      >
                        Budget
                      </div>
                    </Menu.Item>
                    <Menu.Item>
                      <div
                        onClick={() => {
                          history.push("/budget/transaction/recurring");
                        }}
                      >
                        Recurring
                      </div>
                    </Menu.Item>
                  </Menu>
                }
              >
                <a
                  className="ant-dropdown-link"
                  onClick={(e) => e.preventDefault()}
                >
                  <img src={editIcon} height={12} width={18} alt="icon"></img>
                </a>
              </Dropdown>
            </span>
          </div>
          <div className="add-pattren-container">
            <button
              className="addbuttonassets"
              onClick={() => {
                setAddModal(true);
              }}
            >
              {" "}
              + Add Rule
            </button>
          </div>
        </div>
      </div>
      <div className="recurring-token-table" style={{ position: "relative" }}>
        <div
          className="budgetcreate"
          style={{ gap: "1rem", justifyContent: "space-between" }}
        >
          <h3 className="incomecardheading">All Recurring Rules</h3>
          <div
            style={{
              marginBottom: "0px",
              display: "flex",
              alignItems: "center",
              gap: "1rem",
            }}
          >
            <input
              style={{ marginBottom: "0px", height: "33px" }}
              className="searchStyle"
              placeholder="Search"
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                setCurrentPage(1);
              }}
            />
          </div>
        </div>
        <DragDropContext onDragEnd={onDragEnd}>
          <Table
            columns={cols}
            dataSource={recurringTokens && recurringTokens}
            pagination={{
              total: totalPages * 10, // Assuming 10 items per page
              current: currentPage,
              onChange: (page) => {
                setCurrentPage(page);
              },
              pageSize: 10, // Number of items per page
            }}
            rowKey="id"
            locale={{ emptyText: 'No data to show' }}
            components={{
              body: {
                wrapper: DraggableContainer, // Wraps tbody inside Droppable
                row: (props) => {
                  const index =
                    recurringTokens &&
                    recurringTokens.findIndex(
                      (item) => item.id === props["data-row-key"]
                    );
                  return (
                    <DraggableBodyRow
                      {...props}
                      recurringTokens={recurringTokens && recurringTokens}
                      index={index}
                    />
                  );
                }, // Draggable rows
              },
            }}
          />
        </DragDropContext>
        <NewLoader isLoading={loading} />
      </div>
      {addModal && (
        <AddRecurringPattren
          title={modalTitle && modalTitle}
          open={addModal}
          handleChange={handleInputChange}
          handleCancel={handleCancelPattren}
          data={formData && formData}
          handleSave={handleSavePattren}
          selectAll={selectAll}
          setSelectAll={setSelectAll}
        />
      )}
      {tokenModal && (
        <EditRecurringToken
          open={tokenModal}
          handleChange={handleInputChange}
          handleCancel={handleCancelTokenUpdate}
          data={formData && formData}
          handleSave={handleUpdateToken}
        />
      )}
      {pattrenModal && (
        <EditRecurringPattren
          open={pattrenModal}
          handleChange={handleInputChange}
          handleCancel={handleCancelPattrenUpdate}
          data={formData && formData}
          handleSave={handleUpdateTokenPattren}
          handleSaveRule={handleUpdateToken}
          handleDelete={handleDeletePattren}
          handleSaveAddPattren={handleSaveAddPattren}
          loading={loading}
        />
      )}
      <div style={{ position: "relative" }}>
        <SystemRecurringTransactions
          fetchRecuuring={fetchRecuuring}
          recurringGet={recurring}
        />
      </div>
    </div>
  );
};
